module.exports = __webpack_public_path__ + "static/media/cancel.f8fe3cbc.svg";